import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { useEcomPlatform } from 'utils/hooks';
import { UiKit } from 'components';
import { OrderServiceContext } from 'components/OrderServiceDetails';
import { If } from 'utils';
import { getSafeHttpUrl } from 'utils/methods';
import { formatDateTime } from '../../methods';
import ORDER_ROUTES from 'views/Orders/stubs/routes';

const ORDER_ROUTE = ORDER_ROUTES.ORDER_DETAILS;

export default function Header() {
  const { ecommPlatformName } = useEcomPlatform();
  const { orderService, osStatuses, approvalTypes } = useContext(
    OrderServiceContext
  );

  const name = _get(orderService, 'name', '');
  const status = _get(orderService, 'status', '');
  const createdAt = _get(orderService, 'created_at', '');
  const approvalType = _get(orderService, 'approval_type', '');
  const orderInfo = _get(orderService, 'order_info', {});
  const orderId = _get(orderInfo, 'id', '');
  const orderName = _get(orderInfo, 'name', '');
  const ecommOrderUrl = getSafeHttpUrl(_get(orderInfo, 'ecommerce_order_url'));
  const formattedStatus = _get(osStatuses, status, '');
  const formattedApprovalType = _get(approvalTypes, approvalType, '');

  const createdDate = formatDateTime(createdAt);
  const orderDetailsUrl = ORDER_ROUTE.replace(':orderId', orderId);

  return (
    <UiKit.Grid templateColumns="1fr" gap="4" className={styles.container}>
      <UiKit.Grid
        templateColumns="1fr auto"
        gap="16"
        className="align-items-center"
      >
        <h3>{name}</h3>
        <UiKit.Grid
          templateColumns={ecommOrderUrl ? 'auto auto' : 'auto'}
          gap="8"
        >
          <UiKit.Tooltip>
            <UiKit.Tooltip.Trigger>
              <Link to={orderDetailsUrl}>
                <UiKit.Button size="sm" variant="outline" className="px-2">
                  Order Details
                </UiKit.Button>
              </Link>
            </UiKit.Tooltip.Trigger>
            <UiKit.Tooltip.Content>{orderName}</UiKit.Tooltip.Content>
          </UiKit.Tooltip>
          <If test={ecommOrderUrl}>
            <a href={ecommOrderUrl} target="_blank" rel="noopener noreferrer">
              <UiKit.Button size="sm" variant="outline" className="px-2">
                View on {ecommPlatformName}
              </UiKit.Button>
            </a>
          </If>
        </UiKit.Grid>
      </UiKit.Grid>
      <p>Created on: {createdDate}</p>
      <p>
        <strong>{formattedStatus}</strong>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <strong>{formattedApprovalType} Approval</strong>
      </p>
    </UiKit.Grid>
  );
}
